import React from 'react';
import PropTypes from 'prop-types';
import noPitchCreditNeededUrl from '../../../assets/images/no-pitch-credit-needed.png';

function FreeToPitch({ sourceRequest, smallMode, isBroadcastMedia }) {
  const badgeStyle = {
    maxWidth: smallMode ? '120px' : '130px',
    top: '30px',
    right: '15px',
    position: 'absolute',
    zIndex: '1000',
  };

  const isFree = sourceRequest.source_request_free_to_pitch;
  if (!isFree) return null;

  return (
    <img
      src={noPitchCreditNeededUrl}
      alt="No Pitch Credit Needed"
      className={`ms-2 mt-2 free-pitch-badge ${isBroadcastMedia ? 'broadcast-header-present' : ''}`}
      style={badgeStyle}
    />
  );
}

FreeToPitch.propTypes = {
  sourceRequest: PropTypes.instanceOf(Object).isRequired,
  smallMode: PropTypes.bool,
  isBroadcastMedia: PropTypes.bool,
};

FreeToPitch.defaultProps = {
  smallMode: false,
  isBroadcastMedia: false,
};

export default FreeToPitch;
